import React from 'react';

const Checkbox = ({ name, onChange, label, isChecked, labelTitle }) => (
  <div title={labelTitle || label} className="checkbox">
    <input
      value="2"
      id="2"
      type="checkbox"
      name={name}
      onChange={onChange}
      checked={isChecked}
      style={{ cursor: 'pointer' }}
    />
    <label className="text-transparent">{label}</label>
  </div>
);

Checkbox.defaultProps = {
  labelTitle: '',
};

export default Checkbox;
